import { useRouteContext } from '@tanstack/react-router';

export function useCommunicationCapabilities() {
  const { selectedMembership } = useRouteContext({
    from: '/_authenticated/_app',
  });
  const connections = selectedMembership?.connections ?? [];
  const phoneNumbers = selectedMembership?.phoneNumbers ?? [];

  const emailConnection = connections.find((c) => c.id === selectedMembership?.defaultEmailConnectionId);
  const calendarConnection = connections.find((c) => c.capabilities?.canAccessCalendar);

  return {
    canSendEmail: !!emailConnection,
    canAccessCalendar: !!calendarConnection,
    canSendSms: phoneNumbers.some((p) => p.capabilities?.sms),
    canMakeCalls: phoneNumbers.some((p) => p.capabilities?.voice),
    connections,
    phoneNumbers,
    emailConnection,
    calendarConnection,
  };
}
